import * as React from "react"
const SvgSegment = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4.5 20q-.824 0-1.413-.588A1.93 1.93 0 0 1 2.5 18V6q0-.825.587-1.413A1.93 1.93 0 0 1 4.5 4h5.175a1.98 1.98 0 0 1 1.4.575L12.5 6h8q.824 0 1.413.587.587.588.587 1.413v10q0 .825-.587 1.412A1.93 1.93 0 0 1 20.5 20zm0-2h16V8h-8.825l-2-2H4.5zm7-1h8v-.55q0-1.125-1.1-1.788Q17.3 14 15.5 14c-1.8 0-2.167.22-2.9.662q-1.1.663-1.1 1.788zm4-4q.824 0 1.413-.588.587-.587.587-1.412a1.93 1.93 0 0 0-.587-1.413A1.93 1.93 0 0 0 15.5 9q-.825 0-1.412.587A1.93 1.93 0 0 0 13.5 11q0 .825.588 1.412.587.588 1.412.588" />
  </svg>
)
export default SvgSegment
